import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private isAuthenticated = false;
  
  constructor(
    private router: Router,
    private location: Location
  ) {
    this.initializeAuthenticationStatus();
    this.setupNavigationControl();
  }

  private initializeAuthenticationStatus(): void {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    this.isAuthenticated = !!token;
  }

  public setAuthenticationStatus(status: boolean): void {
    this.isAuthenticated = status;
  }

  // Navigue vers le dashboard approprié et efface l'historique
  navigateToDashboardAndClearHistory(role: string): void {
    let dashboardRoute = '/dashboard';
    
    switch (role) {
      case 'adm':
        dashboardRoute = '/dashboard';
        break;
      case 'asst':
        dashboardRoute = '/dash';
        break;
      case 'cmrc':
        dashboardRoute = '/mydash';
        break;
      case 'support':
        dashboardRoute = '/dash-support';
        break;
    }

    // Navigue vers le dashboard et remplace l'historique
    this.router.navigate([dashboardRoute], { replaceUrl: true }).then(() => {
      // Efface complètement l'historique précédent
      history.replaceState(null, '', dashboardRoute);
    });
  }

  // Configure le contrôle de navigation pour empêcher le retour aux pages publiques
  private setupNavigationControl(): void {
    // Écoute les événements de navigation
    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {  // ← Maintenant TypeScript comprend le type
      this.handleNavigationEnd(event);
    });

    // Contrôle le bouton retour du navigateur
    this.setupBrowserBackButtonControl();
  }

  private handleNavigationEnd(event: NavigationEnd): void {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const isAuthenticated = !!token;
    
    // Si l'utilisateur est authentifié et sur une page dashboard
    if (isAuthenticated && this.isDashboardRoute(event.url)) {
      // Remplace l'état de l'historique pour empêcher le retour
      history.replaceState(null, '', event.url);
    }
  }

  private isDashboardRoute(url: string): boolean {
    const dashboardRoutes = ['/dashboard', '/dash', '/mydash', '/dash-support'];
    return dashboardRoutes.includes(url);
  }

  private setupBrowserBackButtonControl(): void {
    window.addEventListener('popstate', (event) => {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const role = localStorage.getItem('role') || sessionStorage.getItem('role');
      
      if (token && role) {
        const currentUrl = this.router.url;
        
        // Si on essaie de revenir vers des pages publiques depuis une page privée
        if (this.isPublicRoute(currentUrl)) {
          event.preventDefault();
          event.stopPropagation();
          
          // Force la redirection vers le dashboard approprié
          this.navigateToDashboardAndClearHistory(role);
        }
      }
    });
  }

  private isPublicRoute(url: string): boolean {
    const publicRoutes = ['/signin', '/index', '/contact', '/functionalities'];
    return publicRoutes.some(route => url.startsWith(route)) || url === '/';
  }
}
